import api from "../axios";

const BASE_URL =
  process.env.NEXT_PUBLIC_API_URL ||
  "https://dev-th-api.neurooceans.com";


export const getAllHelpSections = () =>
  api.get("/doc/help-documentation/");


export const getHelpSection = (section) =>
  api.get("/doc/help-documentation/", {
    params: { section },
  });


export const createHelpSection = (payload) =>
  api.post("/doc/help-documentation/", payload);


export const updateHelpSection = (id, payload) =>
  api.put(`/doc/help-documentation/${id}/`, payload);

export const deleteHelpSection = (id) =>
  api.delete(`/doc/help-documentation/${id}/`);


export const uploadHelpImage = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  // Use axios instance for consistent auth handling
  const response = await api.post("/doc/help-documentation/upload-image/", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};
